'use strict';

function meService($http, $rootScope) {
  var baseURL = '/api/core/me';
  var permissions = [];

  return {
    retrieve: retrieve,
    getPermissions: getPermissions
  };

  function retrieve() {
    return $http.get(baseURL).then(_setPermissionGroup);
  }

  function getPermissions() {
    return permissions;
  }

  function _setPermissionGroup(response) {
    permissions = response.data.groups;
    $rootScope.$broadcast('cenceo.permission.change', permissions);
    return response;
  }
}

module.exports = meService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/auth/service/me/index.js
 ** module id = 169
 ** module chunks = 0
 **/